<template>
  <b-nav class="nav-toggled">
    <!-- <img class="Item" src="@/assets/PentagroIcon2.png" alt="Ícone Pentagro" /> -->
    <b-nav-item-dropdown no-caret text="PCP" class="toggled" left>

      <!-- CADASTROS -->
      <b-dropdown-item to="/productionplanitem" class="drop-item" v-if="user.Permissions.cadastrarvariavel && user.Permissions.cadastrarvariavel.allowed && user.Permissions.cadastrarvariavel.permission">
        <img
          class="dropItem"
          src="@/assets/pop2.png"
          alt="Cadastrar Variável"
        />
        {{ user.Permissions.cadastrarvariavel.permission }}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item"
        :to="`/registerinputs`"
        v-if="user.Permissions.cadastrarinsumo && user.Permissions.cadastrarinsumo.allowed && user.Permissions.cadastrarinsumo.permission"
      >       
        <img class="dropItem" src="@/assets/bottles.png" alt="Cadastro de Insumo" />
        {{ user.Permissions.cadastrarinsumo.permission }} 
      </b-dropdown-item>

      <b-dropdown-item class="drop-item"
        :to="`/harvestplan`"
        v-if="user.Permissions.cadastrarprojecaoagricola && user.Permissions.cadastrarprojecaoagricola.allowed && user.Permissions.cadastrarprojecaoagricola.permission"
      >       
        <img class="dropItem" src="@/assets/agri.png" alt="Cadastrar Premissas de Planejamento" />
        {{ user.Permissions.cadastrarprojecaoagricola.permission }} 
      </b-dropdown-item>
      
      <b-dropdown-item class="drop-item"
        :to="`/materialinputplan`"
       v-if="user.Permissions.cadastrarprojecaoconsumoinsumo && user.Permissions.cadastrarprojecaoconsumoinsumo.allowed && user.Permissions.cadastrarprojecaoconsumoinsumo.permission"
      >       
        <img class="dropItem" src="@/assets/storage.png" alt="Cadastrar Projeção de Consumo de Insumos" />
        {{ user.Permissions.cadastrarprojecaoconsumoinsumo.permission }}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item"
        :to="`/priceprojectionplan`"
       v-if="user.Permissions.cadastrarprojecaoprecoinsumo && user.Permissions.cadastrarprojecaoprecoinsumo.allowed && user.Permissions.cadastrarprojecaoprecoinsumo.permission"
      >       
        <img class="dropItem" src="@/assets/storagecost.png" alt="Projeção de Preço dos Insumos" />
        {{ user.Permissions.cadastrarprojecaoprecoinsumo.permission }}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item"
        :to="`/ltconfigurator`"
        v-if="user.Permissions.configurarlistatecnica && user.Permissions.configurarlistatecnica.allowed && user.Permissions.configurarlistatecnica.permission"
      >       
        <img class="dropItem" src="@/assets/gerenciarplanejamento.png" alt="Cadastrar Projeção da Lista técnica" />
        {{ user.Permissions.configurarlistatecnica.permission }}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item"
        :to="`/productionplancreator`"
        v-if="user.Permissions.efetuarplanejamentoproducao && user.Permissions.efetuarplanejamentoproducao.allowed && user.Permissions.efetuarplanejamentoproducao.permission"
      >       
        <img class="dropItem" src="@/assets/efetuarplanejamento.png" alt="Efetuar Planejamento da Produção" />
        {{ user.Permissions.efetuarplanejamentoproducao.permission }}
      </b-dropdown-item>
      <!-- /CADASTROS -->

      <!-- VISUALIZAÇÕES -->
      <b-dropdown-item class="drop-item"
        :to="`/materialinputview`"
        v-if="user.Permissions.visualizarconsumodeinsumos && user.Permissions.visualizarconsumodeinsumos.allowed && user.Permissions.visualizarconsumodeinsumos.permission"
      >       
        <img class="dropItem" src="@/assets/bottles.png" alt="Visualizar Plano de Consumo de Insumos" />
        {{ user.Permissions.visualizarconsumodeinsumos.permission }}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item"
        :to="`/billofmaterial`"
        v-if="user.Permissions.visualizarlistatecnica && user.Permissions.visualizarlistatecnica.allowed && user.Permissions.visualizarlistatecnica.permission"
      > 
        <img class="dropItem" src="@/assets/listaTecnica.png" alt="Visualizar Plano da Lista Técnica" />
        {{ user.Permissions.visualizarlistatecnica.permission }}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item"
        :to="`/harvestplanview`"
        v-if="user.Permissions.visualizarmoagemeproducao && user.Permissions.visualizarmoagemeproducao.allowed && user.Permissions.visualizarmoagemeproducao.permission"
      >       
        <img class="dropItem" src="@/assets/Planejamento.png" alt="Visualizar Plano de Moagem e Produção" />
        {{ user.Permissions.visualizarmoagemeproducao.permission }}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item"
        :to="`/materialinputpriceview`"
        v-if="user.Permissions.visualizarorcamentodeinsumos && user.Permissions.visualizarorcamentodeinsumos.allowed && user.Permissions.visualizarorcamentodeinsumos.permission"
      >       
        <img class="dropItem" src="@/assets/bottles.png" alt="Visualizar Orçamento de Insumos" />
        {{ user.Permissions.visualizarorcamentodeinsumos.permission }}
      </b-dropdown-item>

      <!-- /VISUALIZAÇÕES -->
      
    </b-nav-item-dropdown>
  </b-nav>
</template>

<script>
import { mapState } from "vuex";
// import { urlMainAPI, defaultSuccess } from "@/global";
// import axios from "axios";



export default {
  name: "PCPDropdown",
  // components: { productionPlanItem },
  computed: mapState(["user", "system"]),
  methods:{    
  }
};
</script>

<style scoped>
img.Item {
  max-height: 37px;
  max-width: 37px;
  border-radius: 5px;
  margin: auto;
}

img.dropItem {
  max-height: 25px;
  max-width: 25px;
  border-radius: 5px;
  margin-right: 10px;
}
</style>

